export const SEARCH_DATA_REDUCER_ACTION_TYPE = {
  FETCH_INIT: 'FETCH_INIT',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_FAIL: 'FETCH_FAIL',
  KEYWORD_UPDATED: 'KEYWORD_UPDATED',
  KEYWORD_EMPTY: 'KEYWORD_EMPTY',
};
